'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { currencyFormatter } from '@/utils/formatters/currency';

interface CartFooterProps {
  total: number;
}

export function CartFooter({ total }: CartFooterProps) {
  return (
    <footer
      className="shrink-0 bg-white p-3 shadow-modal"
      data-testid={DataTestIdEnum.CART_FOOTER}
    >
      <div className="flex items-center gap-2 rounded-xxl border border-gray-300 bg-gray-100 py-2 pl-4 pr-2">
        <p
          className="flex-1 whitespace-nowrap text-lg leading-6 text-gray-800"
          data-testid={DataTestIdEnum.CART_FOOTER_TOTAL}
        >
          Total
          {' '}
          <span className="font-bold">{currencyFormatter(total)}</span>
        </p>

        <Button
          disabled
          className="w-auto shrink-0"
          data-testid={DataTestIdEnum.CART_FOOTER_PROCEED_BUTTON}
        >
          Prosseguir
        </Button>
      </div>
    </footer>
  );
}
